<template>
  <v-container fluid>
    <v-skeleton-loader
      type="table"
    ></v-skeleton-loader>
  </v-container>
</template>

<script>
export default {
  name: 'TableSkeleton'
}
</script>
